var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// Split context and provider to enable auto-generated props docs
import { nanoid } from 'nanoid';
import { useCallback, useMemo, useState } from 'react';
import Toast from './toast';
import { ToastContext } from './toast-context';
import ToastsList from './toasts-list';
function ToastProvider({ autoHideDuration = 6000, children, disableAutoHide: providerDisableAutoHide = false, offset = '60px', }) {
    // Keep each new Toast in a hash map under unique ID
    const [toasts, setToasts] = useState({});
    const toastIds = Object.keys(toasts);
    // Create new Toast, exposed by hook
    const toast = useCallback(({ description, disableAutoHide, size, title, variant = 'info', }) => {
        const toastId = nanoid(6);
        setToasts((newToasts) => {
            return Object.assign(Object.assign({}, newToasts), { [toastId]: {
                    autoHideDuration,
                    description,
                    disableAutoHide: disableAutoHide !== undefined // Check for individual Toast override for disableAutoHide
                        ? disableAutoHide
                        : providerDisableAutoHide,
                    size,
                    title,
                    variant,
                } });
        });
    }, [autoHideDuration, providerDisableAutoHide]);
    const contextValue = useMemo(() => ({ toast }), [toast]);
    // Remove Toast from hash map by ID
    // Handler is called by Toast after exit animation is finished
    // It's called either automatically by internal Toast timer or after close button is clicked
    function handleClose(toastId) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = toasts, _b = toastId, removed = _a[_b], restToasts = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        setToasts(restToasts);
    }
    return (_jsxs(ToastContext.Provider, Object.assign({ value: contextValue }, { children: [toastIds.length > 0 && (_jsx(ToastsList, Object.assign({ offset: offset }, { children: toastIds.map((toastId) => {
                    return (_jsx(Toast, Object.assign({}, toasts[toastId], { onClose: () => handleClose(toastId) }), toastId));
                }) }))), children] })));
}
export default ToastProvider;
